<template>
  <v-card class="add-new-org__card">
    <div class="add-new-org__title h3">Address</div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">
          Address line 1
        </div>
        <form-group
          :validations="$v.organisation.address_line_1"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              class=""
              outlined
              dense
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.address_line_1.$model"
            />
            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>

      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">
          Address line 2
        </div>
        <form-group
          :validations="$v.organisation.address_line_2"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              class=""
              outlined
              dense
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.address_line_2.$model"
            />
            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">
          Town/City
        </div>
        <form-group
          :validations="$v.organisation.city"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              class=""
              outlined
              dense
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.city.$model"
            />
            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">Postcode</div>
        <form-group
          :validations="$v.organisation.postcode"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              class=""
              outlined
              dense
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.postcode.$model"
            />
            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <label for="frmCountryS" class="small-extra-bold ">Country</label>
            <v-form>
            <v-autocomplete
              v-model="organisation.country_id"
              :items="countries"
              hide-details="auto"
              item-text="name"
              item-value="ID"
              outlined
              autocomplete="country-name" id="country" name="country"
              placeholder="Select country"
              :menu-props="{ top: true, offsetY: true }"
              ><apio-icon name="ui-search" slot="append"
                ></apio-icon
              ></v-autocomplete
            ></v-form>
      </v-col>

  
    </v-row>

    <div class="apio__card-actions">
      <apio-button button-type="secondary" @click="stepBack">Back</apio-button>
      <apio-button @click="save" :disabled="!isFormValid">Continue</apio-button>
    </div>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  name: "AddOrgAddressDetails",
  props: {
    organisationDetails: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      title: "",
      organisation: {
        address_line_1: "",
        address_line_2: "",
        city: "",
        postcode: "",
        country_id: "",
      },
    };
  },
  validations: {
    organisation: {
        address_line_1: {
        },
        address_line_2: {
        },
        city: {
        },
        postcode: {
        },
        country_id: {  
          required,
        },
    },
  },
  mixins: [validationMixin],
  components: {
    ApioButton: () => import("@/components/Misc/Button.vue"),
    FormGroup: () => import("@/pages/Account/FormGroup"),
  },
  computed: {
    ...mapState({
      countries: (state) => state.orgs.countries,
    }),
    isFormValid() {
      return !this.$v.$invalid;
    },
    currentOrganisation() {
      return this.$store.state.currentOrganisation;
    },
  },
  created() {
    if(this.$route.params.id) { 
      Object.assign(this.organisation, this.organisationDetails);
      this.$forceUpdate();
    }
  },
  methods: {
    stepBack() {
      const { address_line_1, address_line_2, city, postcode, country_id } = this.organisation;
      this.$emit("step", { org: { address_line_1, address_line_2, city, postcode, country_id }, step: 1 });
    },
    save() {
      const { address_line_1, address_line_2, city, postcode, country_id } = this.organisation;
      this.$emit("step", { org: { address_line_1, address_line_2, city, postcode, country_id }, step: 3 });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-org {
  &__card {
    color: var(--apio-shade-2);
  }
  &__title {
    padding-bottom: 24px;
  }
}
</style>